import { TeamRow } from "@suns/api/generated-client/apollo";
import { Column } from "@/components/ColumnFilters/ColumnFilters";
import { formatMoney, plusMinus } from "@/shared/utils/helper-functions";
import { Flex, Text } from "@suns/design-system";
import { TeamLogo } from "@/components";
import { CapStatusLabels } from "./teams-const";

export const sections = [
  {
    grouping: "General",
    accessorKeys: ["domesticLeagueId", "conference"],
  },
  {
    grouping: "Cap",
    accessorKeys: ["totalCap", "capStatus"],
  },
  {
    grouping: "Evaluation",
    accessorKeys: ["tpv", "oTpv", "dTpv"],
  },
  {
    grouping: "Team Info",
    accessorKeys: ["netRating"],
  },
];

export const columns: Column<TeamRow>[] = [
  {
    header: "Team",
    accessorKey: "fullName",
    cell: (cell) => {
      const team = cell.row.original;

      return (
        <Flex direction="right" align="center" gap="xs" key={team.id}>
          <TeamLogo
            src={team.image}
            nbaTeamId={team.nbaId || team.id}
            leagueId={team.domesticLeagueId}
            size="xxxs"
          />
          <Text size="sm" key={team.id} className="text-nowrap">
            {team.fullName}
          </Text>
        </Flex>
      );
    },
    enableSorting: true,
    enableHiding: false,
    sortingFn: "text",
    sortDescFirst: false,
  },
  {
    header: "League",
    accessorKey: "domesticLeagueId",
    accessorFn: (row: TeamRow) => row.domesticLeague?.name ?? "--",
    enableSorting: true,
    sortingFn: "text",
    sortDescFirst: false,
  },

  {
    header: "Conference",
    accessorKey: "conference",
    accessorFn: (row: TeamRow) => row.conference ?? "--",
    enableSorting: true,
    sortingFn: "text",
    sortDescFirst: false,
  },
  {
    header: "Total Cap",
    accessorKey: "totalCap",
    accessorFn: (row: TeamRow) => formatMoney(row.totalCap),
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },
  {
    header: "Cap Status",
    accessorKey: "capStatus",
    accessorFn: (row: TeamRow) => CapStatusLabels[row.capStatus] ?? "--",
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },

  {
    header: "TPV",
    accessorKey: "tpv",
    accessorFn: (row: TeamRow) => formatMoney(row.metadata[0]?.tpv),
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },
  {
    header: "oTPV",
    accessorKey: "oTpv",
    accessorFn: (row: TeamRow) => formatMoney(row.metadata[0]?.oTpv),
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },
  {
    header: "dTPV",
    accessorKey: "dTpv",
    accessorFn: (row: TeamRow) => formatMoney(row.metadata[0]?.dTpv),
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },

  {
    header: "Net Rating",
    accessorKey: "netRating",
    accessorFn: (row: TeamRow) => plusMinus(row.metadata[0]?.netRating, 1),
    enableSorting: true,
    sortingFn: "alphanumeric",
    sortDescFirst: true,
  },
];
